import { CurrencySelected } from '@/components/Shares/CurrencySelected';
import { Icons } from '@/components/Shares/Icons';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Card, Group, Stack, Text, rem } from '@mantine/core';
import { LanguageSelected } from './LanguageSelected';
import { ThemeSwitch } from './ThemeSwitch';
export const PreferenceAccountCard: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Card radius={5} bg="var(--bg-400)" p={{
    base: 10,
    sm: 20
  }} style={{
    overflow: 'visible'
  }}>
      <Text fz={{
      base: rem(14),
      sm: rem(18)
    }} mt={10} className={gunterzBold.className}>
        {i18n._('Account Preferences')}
      </Text>

      <Stack mt={24}>
        <Group justify="space-between" wrap="nowrap">
          <Group c="var(--text-color-dark-theme)">
            <Icons className="icon-pr-line-currency-dollar-circle" fontSize={25} />
            <Stack gap={0}>
              <Text fz={rem(12)} tt="uppercase" fw={700} c="inherit">
                {i18n._('Fiat view')}
              </Text>
              <Text w={{
              base: 192,
              sm: 299
            }} fz={{
              base: rem(10),
              sm: 'xs'
            }} c="inherit">
                {i18n._('Balances will be displayed in your selected currency')}
              </Text>
            </Stack>
          </Group>
          <CurrencySelected />
        </Group>

        <Group justify="space-between">
          <Group c="var(--text-color-dark-theme)">
            <Icons className="icon-pr-line-internet" fontSize={25} />
            <Stack gap={0}>
              <Text fz={rem(12)} tt="uppercase" fw={700} c="inherit">
                {i18n._('Language')}
              </Text>
              <Text fz={{
              base: rem(10),
              sm: 'xs'
            }} c="inherit">
                {i18n._('Preferred language')}
              </Text>
            </Stack>
          </Group>
          <LanguageSelected />
        </Group>

        <Group justify="space-between">
          <Group c="var(--text-color-dark-theme)">
            <Icons className="icon-pr-line-contrast" fontSize={25} />
            <Stack gap={0}>
              <Text fz={rem(12)} tt="uppercase" fw={700} c="inherit">
                {i18n._('Theme')}
              </Text>
              <Text fz={{
              base: rem(10),
              sm: 'xs'
            }} c="inherit">
                {i18n._('Select between dark or light')}
              </Text>
            </Stack>
          </Group>
          <ThemeSwitch />
        </Group>
      </Stack>
    </Card>;
};